import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 185px;
  background-color: transparent;
  border-radius: 4px;
  padding: 10px 8px;
  transition: background-color 0.15s ease-out;

  &:hover {
    background-color: ${COLORS.gray04};
  }

  .active & {
    background-color: ${COLORS.gray04};
  }
`;

export default Card;
